import ClubAccess from "services/AccessControl/ClubAccess";

export const isAllowed = (subject, role = null, ressource = null) => {
    return (subject?.permissions?.filter(e => {
        return ((role ? e.role === role : true) && (ressource ? ClubAccess(e.groupId, ressource) : true));
    }).length > 0);
}